<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Design system components
	import { Button, ButtonGroupV2, Text } from '@Shelly/shelly-design-system';

	export let typeValue, options, _options;

	const setTypeValue = (_typeValue) => {
		typeValue = _typeValue;
	};

	$: typeLabel = formatSnakeCaseToTitle(
		$format('btn_type_label', { default: 'select input button/switch mode' }),
	);
</script>

<Text class="text-bold mb-s">
	{typeLabel}
</Text>
<ButtonGroupV2
	fullWidth
	noWrap
	orientation="horizontal"
	id="buttongroup-input-type"
	aria-label={typeLabel}
>
	{#each options as option, i (option)}
		<Button
			class={typeValue === option ? 'active' : undefined}
			size="m"
			on:click={() => setTypeValue(option)}
		>
			{_options[i]}
		</Button>
	{/each}
</ButtonGroupV2>
